import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { http, formatApiErrorDetail } from "@/lib/api";

export function useRoles() {
  return useQuery({
    queryKey: ["roles"],
    queryFn: async () => (await http.get("/roles")).data,
  });
}

export function useUpdateRole() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, permissions }) => http.put(`/roles/${id}`, { permissions }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["roles"] });
      qc.invalidateQueries({ queryKey: ["auth"] });
    },
    onError: (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)),
  });
}
